/**
 * @description 判断模块是否是行业频道还是阵地
 * @param【 location.href 】
 * @returns【 ModuleRootPath 】
 */
export const getModuleRootPath = () => {
  var curPageUrl = window.document.location.href;
  if (curPageUrl.includes('/channel-service/position')) {
    return '/channel-service/position';
  } else {
    return '/platform-marketing';
  }
};

/* ******************************** */

/**
 * @description 拼接路径是去除空的query
 * @param【 query string 】
 * @returns【  query string  】
 */
export const killEmptyPath = (queryString) => {
  if (!queryString) return;
  let computedQueryString = '';
  let computedQueryStringMap = [];
  const queryStringMap = queryString.split('&');
  if (queryStringMap && queryStringMap.length > 0) {
    computedQueryStringMap = queryStringMap.filter((item) => {
      const itemMap = item.split('=');
      if (
        itemMap.length > 1 &&
        itemMap[1] &&
        itemMap[1] !== `''` &&
        itemMap[1] !== 'undefined' &&
        itemMap[1] !== 'null'
      ) {
        return true;
      } else {
        return false;
      }
    });
  }
  if (computedQueryStringMap.length > 0) {
    computedQueryString = computedQueryStringMap.join('&');
  }

  return computedQueryString.length > 0 ? `${computedQueryString}` : null;
};
